import { IS_FIREFOX } from 'features'

export const DEFAULT_DATETIME_FORMAT = 'Do MMM YYYY HH:mm'
export const DEFAULT_DATE_FORMAT = 'Do MMM YYYY'
export const DEFAULT_TIME_FORMAT = 'HH:mm'
export const DATETIME_TIMEZONE_FORMAT = 'Do MMM YYYY HH:mm [(GMT] Z[)]'
export const FILE_SIZE_LIMIT = 5000000
export const GA_SITE_ID = 'UA-23850822-1'
export const RECRIGHT_EASY = 'recright-easy'
export const RECRIGHT_PRO2 = 'recright-pro2'
export const CUSTOM_PLAN = 'recright-custom'
export const ATS_PLAN = 'recright-ats'
export const VIDEO_INTERVIEW_PLAN = 'recright-video-interview'
export const PREMIUM_PLAN = 'recright-premium'
export const ESSENTIAL_PLAN = 'recright-essential'
export const PRO_PLAN = 'recright-pro'
// export const SINGLE_HIRE_PLAN = 'single-recruitment'
// export const SINGLE_HIRE_PRICE_FOR_ATS = 295
export const DEFAULT_ITEMS_PER_PAGE = 25
export const ADDITIONAL_FIELDS_LIMIT = 25
export const TIME_UNTIL_MOVING_TO_NEXT_IN_SECONDS = 30
export const DEFAULT_INTRODUCTION_LINK_LIFE_TIME_DAYS = 10

// // possibly rename these

// export const OLD_PRICING_PLANS = [
//   ATS_PLAN,
//   ESSENTIAL_PLAN,
//   PRO_PLAN,
//   PREMIUM_PLAN,
//   SINGLE_HIRE_PLAN,
// ]

// export const NEW_PRICING_PLANS = [
//   // RECRIGHT_EASY, // removed from new pricing plans
//   RECRIGHT_PRO2,
//   PREMIUM_PLAN,
//   SINGLE_HIRE_PLAN,
// ]

// export const BASIC_PLANS = [RECRIGHT_EASY, RECRIGHT_PRO2, SINGLE_HIRE_PLAN]

export const INTERVIEW_PLANS = [
  VIDEO_INTERVIEW_PLAN,
  CUSTOM_PLAN,
  ESSENTIAL_PLAN,
  PRO_PLAN,
  PREMIUM_PLAN,
  RECRIGHT_EASY,
  RECRIGHT_PRO2,
]

export const ATTACHMENT_TYPE_WHITELIST = [
  'png',
  'jpg',
  'gif',
  'jpeg',
  'bmp',
  'webm',
  'mp4',
  'mov',
  'aac',
  'mp3',
  'tif',
  'tiff',
  'psd',
  'ai',
  'eps',
  'pdf',
  'xls',
  'doc',
  'docx',
  'odt',
  'xlsx',
  'ppt',
  'pptx',
  'rtf',
]

export const ATTACHMENT_MIME_TYPE_WHITELIST = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/bmp',
  'video/webm',
  'video/mp4',
  'video/quicktime',
  'audio/aac',
  'audio/mpeg',
  'image/tiff',
  'image/vnd.adobe.photoshop',
  'application/x-photoshop',
  'application/photoshop',
  'application/psd',
  'image/psd',
  'application/postscript',
  'application/eps',
  'application/x-eps',
  'image/eps',
  'image/x-eps',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/rtf',
  'application/rtf',
]

export const BRANDING_FONTS = [
  'Arial',
  'Comfortaa',
  'Cormorant Garamond',
  'Courier New',
  'Didact Gothic',
  'EB Garamond',
  'Georgia',
  'Gill Sans',
  'Impact',
  'Merriweather',
  'Open Sans',
  'Open Sans Condensed',
  'Reckless',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Roboto Slab',
  'Source Sans Pro',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Ubuntu',
  'Ubuntu Condensed',
  'Ubuntu Mono',
  'Verdana',
]

export const BRANDING_EXTRA_LARGE_FONTS = [
  'Verdana',
  'Courier New',
  'Roboto Mono',
  'Comfortaa',
]
export const BRANDING_LARGE_FONTS = [
  'Merriweather',
  'Roboto Slab',
  'Open Sans',
  'Ubuntu Mono',
]
export const BRANDING_SMALL_FONTS = [
  'Gill Sans',
  'Didact Gothic',
  'Times New Roman',
  'EB Garamond',
  'Cormorant Garamond',
]

export const BRANDING_FONT_SUBSETS = {
  el: ['greek'],
  gb: ['cyrillic'],
  ru: ['cyrillic'],
  uk: ['cyrillic'],
}

export const BRANDING_FONTS_TO_NOT_LOAD = [
  'Arial',
  'Courier New',
  'Georgia',
  'Gill Sans',
  'Impact',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
  'Reckless',
]

export const CUSTOM_SUPPORT_TYPES = {
  email: 'email',
  link: 'link',
}

export const PERMISSIONS_NAMES = [
  'seeAllPositions',
  'createJobPositions',
  'createInterviews',
  'account',
  'billing',
  'reporting',
  'editUsers',
]

export const QUESTION_TIME_LABELS = {
  30: '0:30',
  60: '1:00',
  90: '1:30',
  120: '2:00',
  150: '2:30',
  180: '3:00',
  210: '3:30',
  240: '4:00',
  270: '4:30',
  300: '5:00',
}

export const BASE_STAGE_TYPES = ['new', 'hired', 'rejected', 'withdrawn']

export const IFRAME_VIEW_PATH = '/admin/frames/'

export const EMBEDDED_INTERVIEW_PATH = '/interview/profile'

export const INTERCOM_TOURS_PATHS = {
  dashboard: '/admin/',
  candidates: '/admin/interview/:interviewId/candidates',
  interviewEdit: '/admin/interview/:interviewId/edit',
  applications: '/admin/job-ad/:jobAdId/applications',
  jobAdEdit: '/admin/job-ad/:jobAdId/edit',
}

export const VIRTUAL_BG_BLUR_AMOUNT = {
  small: 5,
  large: 9,
}

export const MIN_VIDEO_DIMENSIONS = {
  width: 320,
  height: 240,
}

export const VIDEO_DIMENSIONS = {
  width: 640,
  height: 480,
}

export const HIGH_QUALITY_VIDEO_DIMENSIONS = {
  width: 720,
  height: 540,
}

export const VIDEO_MIMETYPES = {
  mp4: 'video/mp4',
  webm: IS_FIREFOX
    ? 'video/webm;codecs:vp9,opus'
    : 'video/webm;codecs=vp9,opus',
}

export const DEFAULT_INTERVIEW_TITLE_PLACEHOLDER =
  '[INTERVIEW TITLE]'

export const EMAIL_PREVIEW_DEFAULT_TEMPLATE = {
  subject: 'Lorem ipsum',
  message:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ultrices odio ex, non sodales nisl porta vitae. Ut tincidunt eros arcu, in porttitor neque finibus in. Aliquam imperdiet, nibh eget mattis fermentum, lacus felis condimentum ante, vitae tempor arcu augue sed nulla. Morbi molestie rhoncus lacus.\n\n' +
    'Maecenas urna leo, bibendum vitae est id, mollis rhoncus mi. Morbi eu mi tempor, venenatis augue nec, varius ligula. Mauris sed risus eros. Vestibulum eget tortor vitae sapien faucibus pulvinar ut at arcu. Duis enim arcu, fermentum at ante eu, dictum varius ipsum. Fusce vel erat non risus luctus sodales.\n\n' +
    'Quisque ligula magna, scelerisque eu nulla in, vehicula efficitur ipsum. Proin faucibus elit vitae nulla lacinia egestas. Etiam viverra posuere condimentum. Pellentesque dapibus lorem ut nulla scelerisque, at commodo eros tincidunt.\n' +
    'Proin sit amet leo viverra quam sollicitudin fermentum. Ut ultricies elementum lacus, at tincidunt dolor mattis non. Nam ac orci metus. Ut ultricies pellentesque mattis. Praesent posuere mollis tincidunt. Proin vehicula, tortor id gravida volutpat, est nisi consectetur risus, sed tristique ex augue commodo odio.\n\n',
  url: 'https://www.recright.com',
  signature: 'Best regards',
  name: 'Recright',
}

export const INTERVIEW_INVITE_TEMPLATE_TYPES = [
  'interviewInvite',
  'timedInterviewInvite',
]

export const INTERVIEW_TEMPLATE_TYPES = [
  ...INTERVIEW_INVITE_TEMPLATE_TYPES,
  'interviewCompleted',
]

export const JOB_AD_TEMPLATE_TYPES = ['applicationCompleted']

export const TEMPLATES_WITH_NAME_FIELD = INTERVIEW_INVITE_TEMPLATE_TYPES

export const EMAIL_TEMPLATE_TYPES = [
  ...INTERVIEW_INVITE_TEMPLATE_TYPES,
  'interviewCompleted',
  'applicationCompleted',
]
export const EMBEDDED_INTERVIEW_PATHS = {
  embed: '/interview/embedded/',
  profile: 'interview/profile/',
}


export const BROWSER_RECORDERS = [
  'rtc',
  'mediarecorder',
  'mediarecorder-bg',
  'mediarecorder-normal',
]

// Bg not allowed in safari but maybe in the future.
export const SAFARI_MP4_RECORDERS = [
  'safari-rtc',
  'safari-mp4-mediarecorder-normal',
  'safari-mp4-mediarecorder-bg',
]
